export default "__VITE_ASSET__BAb1E8UB__"